import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import callable from '../utils/callable'
import { getEmployeeApprovalCodes } from '../selectors/employeeRole'

import Keypad from '../components/tabs/TabOrderDetailsKeypad'

/**
 * TODO: It is unconvential to return React components in a hook.
 * This should be replace with a more convential and flexible system
 * When time permits.
 */
const useValidateEmployeePin = () => {
  const approvalCodes = useSelector(getEmployeeApprovalCodes)

  const requestApproval = (pin, success, failure) => {
    if (approvalCodes.includes(pin)) {
      callable(success)
    } else {
      callable(failure)
      toast.error('Invalid Approval Code, Please Try Again', { autoClose: 2500 })
    }
  }

  return requestApproval
}

export default useValidateEmployeePin
